module.exports = __webpack_public_path__ + "static/media/user.96aa882e.svg";